<div class="my-3 my-md-5">
    <div class="container" *ngIf="myrole=='1' || myrole=='3' || myrole=='15' ">
        <div class="row">
            <div class="page-header">
                <span class="bold">C2C Report</span>
            </div>
            <mat-accordion class="example-headers-align w-100" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2">
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                                <input class="mySearchInput"
                                #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bd_search">
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-3 mt-2">
                            <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" (click)="setSearchValue('leadCategory')" multiple>
                                <input class="mySearchInput"
                                #leadcategorySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'leadCategory')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="leadcategorySearch">
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="picker" #dateRangeStart placeholder="Choose a date" (dateChange)="dateRangeChange(dateRangeStart)">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                      
    
                        <div class="col-sm-3 mt-2">
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="gettocReportList()"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        </div>
            
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive" style="height: 700px;">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr *ngIf="ctoc_report_loading">
                                <td colspan="4" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <!-- <th colspan="10">C2C Report of  <b>{{todayDate  | date }}</b></th> -->
                                <th colspan="10"> C2C Report of
                                      <span *ngIf="showFilterDate.length > 0; else today_Date"><b>{{showFilterDate | date}}</b></span>
                                      <ng-template #today_Date>
                                        <b>{{todayDate  | date }}</b>
                                    </ng-template>
                                </th>
                            </tr>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>BD Name</th>
                                <th>Call Attempts (150)</th>
                                <th>Call Connected (50)</th>
                                <th>Talk Time (180 min)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let ctocdata of ctocReportLists; let index = index;" >
                                <td style="width: 3%;">{{index+1}}</td>
                                <td>{{ctocdata.name}}</td>
                                <td>{{ctocdata.total_no_of_call_attempts ? ctocdata.total_no_of_call_attempts : 0}}</td>
                                <td>{{ctocdata.call_connected ? ctocdata.call_connected : 0}}</td>
                                <td>{{converttominfromsec(ctocdata.talk_time)}}</td>
                            </tr> 
                            <tr class="text-center">
                                <td style="width: 3%;"></td>
                                <td><b>Total</b></td>
                                <td><b>{{callAtmentTotal}}</b></td>
                                <td><b>{{callConnectTotal}}</b></td>
                                <td></td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 
    </div>

    <div class="container" *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access != '1') ">
        <div class="row">
            <div class="page-header">
                <span class="bold">C2C Report FeedBack</span>
            </div>
            <mat-accordion class="example-headers-align w-100" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2">
                            <mat-select  placeholder="Bds" [(ngModel)]="feedbackbd" (click)="setSearchValue('feedbackbds')" multiple #itemSelect="ngModel">
                                <input class="mySearchInput"
                                #feedbackbd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'feedbackbds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="feedbackbd_search">
                                <mat-option value="{{fbd.id}}" *ngFor="let fbd of feedbackBds">{{fbd.name}}</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="picker" #dateRangeStartFeedback placeholder="Choose a date" (dateChange)="dateRangeChangeFeedback(dateRangeStartFeedback)">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
    
                        <div class="col-sm-3 mt-2">
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="gettocReportListForFeedBack()"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        </div>
            
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

        </div>
        
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive" style="height: 500px;">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr *ngIf="ctoc_report_loading_feedback">
                                <td colspan="4" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <!-- <th colspan="10">C2C Report of  <b>{{todayDate  | date }}</b></th> -->
                                <th colspan="10"> C2C Report of
                                    <span *ngIf="showFilterDateFeedback.length > 0; else today_Date_feedback"><b>{{showFilterDateFeedback | date}}</b></span>
                                    <ng-template #today_Date_feedback>
                                      <b>{{todayDate  | date }}</b>
                                  </ng-template>
                              </th>
                            </tr>
                            <tr class="text-center">
                                <th style="width: 3%;">#</th>
                                <th>BD Name</th>
                                <th>Call Attempts (150)</th>
                                <th>Call Connected (50)</th>
                                <th>Talk Time (180 min)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let ctocdata of ctocReportListsFeedback;let index = index;">
                                <td style="width: 3%;">{{index+1}}</td>
                                <td>{{ctocdata.name}}</td>
                                <td>{{ctocdata.total_no_of_call_attempts ? ctocdata.total_no_of_call_attempts : 0}}</td>
                                <td>{{ctocdata.call_connected ? ctocdata.call_connected : 0}}</td>
                                <td>{{converttominfromsec(ctocdata.talk_time)}}</td>
                            </tr> 
                            <tr class="text-center">
                                <td style="width: 3%;"></td>
                                <td><b>Total</b></td>
                                <td><b>{{callAtmentTotalFeedbackUser}}</b></td>
                                <td><b>{{callConnectTotalFeedbackUser}}</b></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 
    </div>
</div>
